import { VendorSearchDataAction } from "../../actions/vendor/VendorSearchDataAction";
import { SAPVendor } from "../../models/SAPVendor";

// export interface VendorBlockData {
//   CompanyCode: string;
//   SAPVendorList : SAPVendor[];  
//   VendorBlockdata : SAPVendor[]; 
// }

// const initialState = {
// CompanyCode: "",
// SAPVendorList: [],
// VendorBlockdata : []
// };

export function VendorSearchDataReducer(
  state: SAPVendor[] = [],
  action: VendorSearchDataAction
): SAPVendor[] {
  switch (action.type) {
    case "ON_CHANGE_VENDOR_SEARCH_DATA":
      return [...action.payload];     
    default:
      return state;
  }
}
